import { getNavEntry } from '../../utils/getNavEntry';
/**
 * Simplified navigation/load related metrics factory. Provide the event type and the calculation function, which will receive the navigation entry.
 */
export function simpleMetricFactory(type, calc) {
    var sent = false;
    return function () {
        var pageNav = getNavEntry();
        if (sent || !pageNav)
            return false; // The entry is not here yet, or the data was already sent.
        var val = calc(pageNav);
        if (!val)
            return false;
        else {
            sent = true;
            return {
                eventTypeId: type,
                value: val,
            };
        }
    };
}
